import dayjs from "dayjs";
import type { DanmakuItem } from "./constants";
import {
  DANMAKU_AVATARS,
  DANMAKU_VISIBLE_COUNT,
  LIVE_SHARE_DESIGN_WIDTH,
  MOCK_DANMAKU_ARRIVAL_POOL,
  MOCK_DANMAKU_PREDICTION_POOL,
} from "./constants";

const win: any = window;

const screenWidth = window.screen.width;
const calcLiveShareRatio = (size: number) =>
  (size * screenWidth) / LIVE_SHARE_DESIGN_WIDTH;

/** 背景日期文案：设计稿 left 240 / top 306 / font 13（与 fifaGetCoupon RATIOS 同一套换算） */
export const LIVE_SHARE_DATE_LABEL_LAYOUT = {
  left: calcLiveShareRatio(245),
  top: calcLiveShareRatio(247),
  fontSize: calcLiveShareRatio(13),
};

/** 当前日期，如 4月15日（与红包页 Top 展示习惯一致，无前导零） */
export const formatLiveShareCurrentDate = () => dayjs().format("M月D日");

export const getPageSourceFromRouter = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const pageSource = searchParams.get("page_source") || "";
  return pageSource;
};

export const goTrick = (btnName = "打开看看") => {
  win?.sensors?.track("buttonClick", {
    belong_page: "2026FIFA直播间分享H5页",
    page_source: getPageSourceFromRouter(),
    button_name: btnName,
  });
};

/** 从数组里随机取 1 条 */
const pickOneRandom = <T,>(list: T[]): T | undefined => {
  if (!list.length) return undefined;
  return list[Math.floor(Math.random() * list.length)];
};

/** 从数组里随机取 count 条（不重复下标） */
const pickRandomItems = <T,>(list: T[], count: number): T[] => {
  const picked: T[] = [];
  const usedIndex = new Set<number>();
  const max = Math.min(count, list.length);

  while (picked.length < max) {
    const idx = Math.floor(Math.random() * list.length);
    if (usedIndex.has(idx)) continue;
    usedIndex.add(idx);
    picked.push(list[idx]);
  }
  return picked;
};

/** 从预测池随机取 count 条，nickname 不与 excludeNickname 相同 */
const pickRandomPredictions = (
  pool: DanmakuItem[],
  excludeNickname: string,
  count: number
): DanmakuItem[] => {
  const candidates = pool.filter(
    (item) => item?.nickname && item.nickname !== excludeNickname
  );
  return pickRandomItems(candidates, count);
};

/** 为每条弹幕分配互不相同的 avatar */
const attachUniqueAvatars = (items: DanmakuItem[]): DanmakuItem[] => {
  const avatars = pickRandomItems(DANMAKU_AVATARS, items.length);
  return items.map((item, index) => ({
    ...item,
    avatar: avatars[index],
  }));
};

/**
 * 展示 4 条弹幕：「来了」池随机 1 条 + 预测池随机 3 条（昵称与「来了」不重复），展示顺序随机。
 */
export const pickRandomDanmaku = (): DanmakuItem[] => {
  const arrival = pickOneRandom(MOCK_DANMAKU_ARRIVAL_POOL);
  if (!arrival?.nickname) return [];

  const predictions = pickRandomPredictions(
    MOCK_DANMAKU_PREDICTION_POOL,
    arrival.nickname,
    DANMAKU_VISIBLE_COUNT - 1
  );

  const lines = pickRandomItems([arrival, ...predictions], DANMAKU_VISIBLE_COUNT);
  return attachUniqueAvatars(lines);
};
